import React from "react";
import { ArrowUp, ArrowDown } from "lucide-react";

const StatCard = ({ stat }) => {
  return (
    <div className="bg-gray-800 rounded-lg p-6 shadow-lg hover:bg-gray-700/50 transition-colors">
      <div className="flex justify-between">
        <div>
          <p className="text-gray-400 text-sm">{stat.name}</p>
          <p className="text-white text-2xl font-semibold mt-1">{stat.value}</p>
        </div>
        <div className="bg-gray-700 h-10 w-10 rounded-full flex items-center justify-center">
          {stat.icon}
        </div>
      </div>

      <div className="mt-4 flex items-center">
        <span
          className={`flex items-center text-xs ${
            stat.increased ? "text-green-500" : "text-red-500"
          }`}
        >
          {stat.increased ? (
            <ArrowUp size={12} className="mr-1" />
          ) : (
            <ArrowDown size={12} className="mr-1" />
          )}
          {stat.change}
        </span>
        <span className="text-gray-400 text-xs ml-1">vs. mes anterior</span>
      </div>
    </div>
  );
};

export default StatCard;
